import { components } from "../../../types/api";
import { AppExceptionType } from "../../../types/ErrorTypes";

export type CampaignStateType = {
  campaings: TaboolaCampaigns;
  isLoadingFetchCampaigns: boolean;
  errorFetchingCampaigns: AppExceptionType;
};

export type TaboolaCampaigns = Array<TaboolaCampaign>;
export type TaboolaCampaign = components["schemas"]["TaboolaCampaign"];

export type FetchTaboolaCampaignsApiResponse =
  components["schemas"]["ApiResponse_TaboolaCampaignsResponse_"];

export type CampaignGoals = components["schemas"]["CampaignGoal"];

export const CAMPAIGN = "campaign";
